import { render } from "./TuBiao.vue?vue&type=template&id=7037f63c&scoped=true"
import script from "./TuBiao.vue?vue&type=script&lang=js"
export * from "./TuBiao.vue?vue&type=script&lang=js"

import "./TuBiao.vue?vue&type=style&index=0&id=7037f63c&lang=scss&scoped=true"

import exportComponent from "E:\\vue-cli-pc\\测试环境\\exp2c.com\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7037f63c"]])

export default __exports__